export default "__VITE_ASSET__C5gPO3LH__"